import type { AsyncBelongsTo } from '@ember-data/model';
import Model from '@ember-data/model';

/**
 * Narrow an Ember Data async belongs-to union (`AsyncBelongsTo<T> | T`) to the
 * synchronous record when it's already resolved. Returns `undefined` if the
 * proxy hasn't been sideloaded yet so callers can branch explicitly rather
 * than silently coercing missing data to a falsy primitive.
 */
export default function resolveSync<T extends Model>(rel: AsyncBelongsTo<T> | T | undefined): T | undefined {
  if (!rel) return undefined;
  if (rel instanceof Model) return rel;
  return rel.content ?? undefined;
}
